import React, { memo, useMemo } from 'react';
import { useRadioGroup, Flex, Box, VisuallyHidden } from '@chakra-ui/react';

import { ECustomTipsMode, ESpecialTipsValue, TipsValue } from '@olo-web/domain/orders/types';
import { TipsRadioButton } from '@olo-web/components/atoms/TipsSection/TipsRadioButton.ui';
import { getTipsOptions } from '@olo-web/domain/orders/functions/getTipsOptions';
import { useMerchantOrderTypeDetails } from '@domain/merchants/queries/useMerchantOrderTypeDetails';
import { useOrderTipsDispatch } from '@olo-web/client-state';
import { useCurrentOrderTips, useIsThirdPartyDelivery } from '@olo-web/utils/common/hooks';
import { useRouter } from 'next/router';

const useTipsOptions = () => {
  const { data: orderTypeDetails } = useMerchantOrderTypeDetails();
  const isThirdPartyDelivery = useIsThirdPartyDelivery();

  return useMemo(
    () => getTipsOptions(orderTypeDetails, isThirdPartyDelivery),
    [orderTypeDetails, isThirdPartyDelivery]
  );
};
const TipsRadioGroupComponent = (props) => {
  const { selectedTips } = useCurrentOrderTips();
  const orderTipsDispatch = useOrderTipsDispatch();
  const tipsOptions = useTipsOptions();
  const router = useRouter();
  const { merchantId } = router.query;

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: 'tips',
    value: selectedTips,
    onChange: (nextValue: TipsValue) => {
      if (nextValue === ESpecialTipsValue.CUSTOM) {
        orderTipsDispatch({
          type: 'TIPS_MODE_CHANGE',
          payload: {
            merchantId: merchantId as string,
            value: ECustomTipsMode.AMOUNT,
          },
        });
      }

      orderTipsDispatch({
        type: 'TIPS_VALUE_CHANGE',
        payload: {
          merchantId: merchantId as string,
          value: nextValue,
        },
      });
    },
  });

  return (
    <Box as="fieldset" border="none" p={0} m={0} mb="16px" w="100%">
      <VisuallyHidden as="legend">Tip amount</VisuallyHidden>
      <Flex {...getRootProps()} id="tips-selection-button-group" {...props}>
        {tipsOptions.map(({ value, label }) => {
          const radio = getRadioProps({ value });

          return (
            <TipsRadioButton key={label} {...radio}>
              {label}
            </TipsRadioButton>
          );
        })}
      </Flex>
    </Box>
  );
};

export const TipsRadioGroup = memo(TipsRadioGroupComponent);
